module.exports = __webpack_public_path__ + "img/ic_linkedin.89c9fcdd.svg";